import { render, staticRenderFns } from "./science-technology-are-digital.vue?vue&type=template&id=2abb672c&scoped=true"
import script from "./science-technology-are-digital.vue?vue&type=script&lang=js"
export * from "./science-technology-are-digital.vue?vue&type=script&lang=js"
import style0 from "./science-technology-are-digital.vue?vue&type=style&index=0&id=2abb672c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abb672c",
  null
  
)

export default component.exports